<template>
  <div class="auth-wrapper auth-v1">
    <div class="auth-inner">
      <v-card class="auth-card">
        <!-- logo -->
        <v-card-title class="d-flex align-center justify-center py-7">
          <router-link
            to="/"
            class="d-flex align-center"
          >
            <v-img
              :src="appLogo"
              max-height="30px"
              max-width="30px"
              alt="logo"
              contain
              class="me-3 "
            ></v-img>

            <h2 class="text-2xl font-weight-semibold">
              LYS BLEU EDITIONS
            </h2>
          </router-link>
        </v-card-title>

        <!-- title -->
        <v-card-text>
<!--          <p>
            <svg height="100%" viewBox="0 0 206 67" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
    <g transform="matrix(1,0,0,1,-73.0401,-144.736)">
        <g transform="matrix(0.870642,0,0,1.16086,-93.8392,103.976)">
            <g transform="matrix(75.7812,15.2291,20.3055,-56.8359,192.277,56.2414)">
                <path d="M0.362,0.452C0.367,0.432 0.358,0.405 0.347,0.373C0.336,0.342 0.324,0.306 0.321,0.263C0.249,0.292 0.182,0.287 0.127,0.283C0.085,0.28 0.048,0.278 0.024,0.292C0.016,0.296 0.007,0.293 0.002,0.286C-0,0.282 -0.001,0.278 0.001,0.274C0.002,0.27 0.004,0.266 0.008,0.264C0.032,0.25 0.048,0.217 0.067,0.179C0.091,0.129 0.12,0.069 0.181,0.021C0.146,-0.003 0.121,-0.032 0.099,-0.057C0.077,-0.082 0.058,-0.104 0.038,-0.109C0.029,-0.111 0.024,-0.12 0.027,-0.129C0.029,-0.137 0.037,-0.142 0.046,-0.14C0.066,-0.134 0.094,-0.144 0.125,-0.154C0.156,-0.165 0.193,-0.178 0.235,-0.181C0.207,-0.253 0.211,-0.32 0.215,-0.375C0.218,-0.417 0.221,-0.454 0.207,-0.478C0.205,-0.482 0.204,-0.486 0.205,-0.49C0.206,-0.494 0.209,-0.497 0.213,-0.5C0.216,-0.502 0.221,-0.502 0.225,-0.501C0.229,-0.5 0.232,-0.498 0.234,-0.494C0.248,-0.47 0.281,-0.454 0.319,-0.435C0.369,-0.411 0.429,-0.381 0.478,-0.321C0.501,-0.356 0.53,-0.381 0.555,-0.403C0.58,-0.425 0.602,-0.444 0.607,-0.464C0.61,-0.472 0.618,-0.478 0.627,-0.475C0.635,-0.473 0.64,-0.464 0.638,-0.456C0.633,-0.435 0.642,-0.408 0.653,-0.377C0.664,-0.345 0.676,-0.309 0.679,-0.267C0.751,-0.295 0.818,-0.29 0.873,-0.287C0.915,-0.284 0.952,-0.281 0.976,-0.295C0.98,-0.297 0.984,-0.298 0.988,-0.297C0.992,-0.296 0.996,-0.293 0.998,-0.289C1,-0.285 1.001,-0.281 0.999,-0.277C0.998,-0.273 0.996,-0.27 0.992,-0.268C0.968,-0.254 0.952,-0.221 0.933,-0.182C0.909,-0.133 0.88,-0.072 0.819,-0.024C0.854,-0.001 0.879,0.028 0.901,0.054C0.923,0.079 0.942,0.1 0.962,0.106C0.971,0.108 0.976,0.117 0.973,0.125C0.971,0.134 0.963,0.139 0.954,0.136C0.934,0.131 0.906,0.14 0.875,0.151C0.844,0.162 0.807,0.174 0.765,0.177C0.793,0.249 0.789,0.316 0.785,0.371C0.782,0.414 0.779,0.45 0.793,0.474C0.795,0.478 0.796,0.483 0.795,0.486C0.794,0.49 0.791,0.494 0.787,0.496C0.78,0.501 0.77,0.498 0.766,0.49C0.752,0.466 0.719,0.45 0.681,0.431C0.631,0.407 0.571,0.378 0.522,0.317C0.499,0.352 0.47,0.378 0.445,0.4C0.42,0.421 0.398,0.44 0.393,0.461C0.39,0.469 0.382,0.474 0.373,0.472C0.365,0.469 0.36,0.461 0.362,0.452ZM0.416,0.13C0.409,0.141 0.399,0.15 0.388,0.156C0.382,0.16 0.376,0.163 0.37,0.165C0.37,0.166 0.37,0.166 0.37,0.166C0.366,0.173 0.362,0.181 0.36,0.189C0.356,0.205 0.353,0.221 0.353,0.236C0.353,0.239 0.353,0.241 0.352,0.243C0.352,0.289 0.365,0.328 0.377,0.363C0.382,0.378 0.387,0.392 0.391,0.406C0.4,0.396 0.412,0.386 0.424,0.376C0.463,0.342 0.507,0.303 0.526,0.233C0.528,0.225 0.529,0.216 0.529,0.208C0.525,0.203 0.521,0.197 0.518,0.191C0.511,0.18 0.508,0.167 0.507,0.154C0.5,0.145 0.49,0.139 0.48,0.134L0.445,0.264C0.443,0.273 0.434,0.278 0.426,0.275C0.417,0.273 0.412,0.264 0.415,0.256L0.449,0.125C0.438,0.125 0.427,0.126 0.416,0.13ZM0.557,0.241C0.552,0.258 0.546,0.274 0.539,0.287C0.584,0.349 0.643,0.378 0.695,0.403C0.715,0.413 0.734,0.422 0.751,0.433C0.75,0.413 0.752,0.392 0.753,0.369C0.757,0.312 0.762,0.247 0.731,0.177C0.715,0.176 0.699,0.173 0.682,0.169C0.681,0.168 0.68,0.168 0.679,0.168C0.683,0.193 0.681,0.216 0.68,0.236C0.678,0.256 0.677,0.273 0.683,0.284C0.685,0.288 0.686,0.292 0.685,0.296C0.684,0.3 0.681,0.303 0.677,0.305C0.67,0.31 0.66,0.307 0.656,0.3C0.65,0.289 0.634,0.282 0.616,0.273C0.598,0.264 0.577,0.254 0.557,0.238C0.557,0.239 0.557,0.24 0.557,0.241ZM0.095,0.193C0.085,0.213 0.076,0.233 0.065,0.249C0.085,0.248 0.106,0.25 0.129,0.251C0.187,0.255 0.252,0.26 0.321,0.229C0.322,0.214 0.325,0.197 0.329,0.181C0.33,0.179 0.33,0.178 0.331,0.177C0.306,0.181 0.283,0.18 0.262,0.178C0.242,0.177 0.225,0.175 0.215,0.181C0.207,0.186 0.197,0.183 0.193,0.176C0.191,0.172 0.19,0.167 0.191,0.164C0.192,0.16 0.195,0.156 0.199,0.154C0.209,0.148 0.217,0.132 0.225,0.114C0.234,0.096 0.244,0.075 0.26,0.056C0.259,0.055 0.258,0.055 0.257,0.055C0.24,0.05 0.225,0.044 0.211,0.038C0.149,0.083 0.121,0.141 0.095,0.193ZM0.541,0.138C0.537,0.151 0.539,0.164 0.546,0.175C0.568,0.214 0.601,0.23 0.63,0.244C0.636,0.247 0.641,0.25 0.647,0.253C0.647,0.247 0.648,0.24 0.648,0.234C0.65,0.201 0.653,0.165 0.631,0.126C0.624,0.115 0.614,0.107 0.601,0.103C0.593,0.101 0.586,0.101 0.579,0.103L0.607,0.152C0.611,0.159 0.609,0.169 0.601,0.173C0.594,0.178 0.584,0.175 0.579,0.168L0.551,0.118C0.546,0.124 0.543,0.131 0.541,0.138ZM0.323,0.044C0.284,0.066 0.268,0.099 0.254,0.128C0.251,0.134 0.248,0.14 0.245,0.145C0.252,0.146 0.258,0.146 0.265,0.146C0.297,0.149 0.333,0.151 0.372,0.129C0.383,0.122 0.392,0.112 0.395,0.099C0.397,0.092 0.397,0.084 0.396,0.077L0.347,0.105C0.339,0.11 0.329,0.107 0.325,0.099C0.32,0.092 0.323,0.082 0.331,0.078L0.38,0.049C0.374,0.044 0.368,0.041 0.36,0.039C0.347,0.035 0.334,0.037 0.323,0.044ZM0.499,0.065L0.488,0.103C0.498,0.106 0.506,0.111 0.514,0.118C0.519,0.107 0.526,0.098 0.535,0.09L0.519,0.062C0.512,0.064 0.505,0.065 0.499,0.065ZM0.424,0.06C0.428,0.071 0.429,0.083 0.428,0.094C0.438,0.093 0.448,0.093 0.458,0.094L0.468,0.057C0.462,0.053 0.456,0.049 0.452,0.044L0.424,0.06ZM0.631,0.082C0.642,0.089 0.652,0.099 0.658,0.11C0.662,0.116 0.664,0.122 0.667,0.128C0.674,0.132 0.682,0.136 0.691,0.138C0.761,0.157 0.816,0.138 0.865,0.121C0.88,0.116 0.894,0.111 0.908,0.108C0.898,0.098 0.888,0.086 0.877,0.074C0.843,0.035 0.805,-0.009 0.735,-0.028C0.727,-0.03 0.718,-0.031 0.709,-0.03C0.704,-0.027 0.699,-0.023 0.693,-0.02C0.682,-0.013 0.669,-0.009 0.656,-0.009C0.647,-0.001 0.64,0.008 0.635,0.018L0.766,0.053C0.774,0.055 0.779,0.064 0.777,0.073C0.775,0.081 0.766,0.086 0.758,0.084L0.627,0.049C0.626,0.06 0.628,0.071 0.631,0.082ZM0.135,-0.124C0.12,-0.119 0.106,-0.114 0.092,-0.111C0.102,-0.101 0.112,-0.09 0.123,-0.078C0.157,-0.039 0.195,0.005 0.265,0.024C0.273,0.026 0.282,0.027 0.291,0.027C0.296,0.023 0.301,0.02 0.307,0.016C0.319,0.01 0.331,0.006 0.344,0.005C0.353,-0.002 0.36,-0.011 0.365,-0.022L0.234,-0.057C0.226,-0.059 0.221,-0.068 0.223,-0.076C0.225,-0.084 0.234,-0.09 0.242,-0.087L0.373,-0.052C0.374,-0.064 0.372,-0.075 0.369,-0.086C0.358,-0.093 0.348,-0.102 0.342,-0.114C0.338,-0.12 0.336,-0.126 0.333,-0.131C0.326,-0.136 0.318,-0.139 0.309,-0.142C0.239,-0.16 0.184,-0.141 0.135,-0.124ZM0.546,0.046L0.562,0.074C0.573,0.07 0.585,0.069 0.596,0.07C0.595,0.06 0.595,0.05 0.596,0.04L0.558,0.03C0.555,0.036 0.551,0.042 0.546,0.046ZM0.381,0.013C0.391,0.017 0.401,0.024 0.408,0.033L0.436,0.017C0.434,0.01 0.433,0.004 0.433,-0.003L0.396,-0.013C0.392,-0.004 0.387,0.005 0.381,0.013ZM0.466,-0.011C0.461,0.008 0.472,0.027 0.491,0.032C0.51,0.037 0.529,0.026 0.534,0.007C0.539,-0.011 0.528,-0.031 0.509,-0.035C0.49,-0.04 0.471,-0.029 0.466,-0.011ZM0.564,-0.02C0.566,-0.014 0.567,-0.007 0.567,-0L0.604,0.01C0.608,0.001 0.613,-0.008 0.619,-0.016C0.609,-0.021 0.599,-0.028 0.592,-0.036L0.564,-0.02ZM0.404,-0.074C0.405,-0.064 0.405,-0.054 0.404,-0.044L0.442,-0.034C0.445,-0.04 0.449,-0.045 0.454,-0.05L0.438,-0.078C0.427,-0.074 0.415,-0.073 0.404,-0.074ZM0.542,-0.098L0.532,-0.06C0.538,-0.057 0.544,-0.053 0.548,-0.048L0.576,-0.064C0.572,-0.075 0.571,-0.086 0.572,-0.098C0.562,-0.097 0.552,-0.097 0.542,-0.098ZM0.465,-0.094L0.481,-0.066C0.488,-0.068 0.495,-0.069 0.501,-0.068L0.512,-0.106C0.502,-0.11 0.494,-0.115 0.486,-0.121C0.481,-0.11 0.474,-0.101 0.465,-0.094ZM0.352,-0.237C0.35,-0.205 0.347,-0.168 0.369,-0.13C0.376,-0.118 0.386,-0.11 0.399,-0.107C0.407,-0.105 0.414,-0.105 0.421,-0.106L0.393,-0.155C0.389,-0.163 0.391,-0.172 0.399,-0.177C0.403,-0.179 0.407,-0.18 0.411,-0.178C0.415,-0.177 0.418,-0.175 0.421,-0.171L0.449,-0.122C0.454,-0.128 0.457,-0.134 0.459,-0.142C0.463,-0.154 0.461,-0.168 0.454,-0.179C0.432,-0.218 0.399,-0.234 0.37,-0.248C0.364,-0.251 0.359,-0.254 0.353,-0.256C0.353,-0.25 0.352,-0.244 0.352,-0.237ZM0.675,-0.103C0.68,-0.095 0.677,-0.086 0.669,-0.081L0.62,-0.053C0.626,-0.048 0.632,-0.044 0.64,-0.042C0.653,-0.039 0.666,-0.041 0.677,-0.047C0.716,-0.07 0.732,-0.102 0.746,-0.131C0.749,-0.137 0.752,-0.143 0.755,-0.149C0.748,-0.149 0.742,-0.149 0.735,-0.15C0.703,-0.152 0.667,-0.155 0.628,-0.132C0.617,-0.126 0.608,-0.115 0.605,-0.103C0.603,-0.095 0.603,-0.088 0.604,-0.08L0.653,-0.109C0.657,-0.111 0.662,-0.111 0.665,-0.11C0.669,-0.109 0.673,-0.107 0.675,-0.103ZM0.789,-0.041C0.851,-0.086 0.879,-0.145 0.905,-0.196C0.915,-0.217 0.924,-0.236 0.935,-0.253C0.915,-0.252 0.894,-0.253 0.871,-0.255C0.813,-0.259 0.749,-0.263 0.679,-0.232C0.678,-0.217 0.675,-0.201 0.671,-0.184C0.67,-0.183 0.67,-0.182 0.67,-0.181C0.694,-0.185 0.717,-0.183 0.738,-0.182C0.758,-0.18 0.775,-0.179 0.785,-0.185C0.789,-0.187 0.794,-0.188 0.798,-0.186C0.801,-0.185 0.805,-0.183 0.807,-0.179C0.809,-0.175 0.81,-0.171 0.809,-0.167C0.808,-0.163 0.805,-0.16 0.801,-0.157C0.791,-0.151 0.783,-0.136 0.775,-0.118C0.766,-0.099 0.756,-0.079 0.74,-0.059C0.741,-0.059 0.742,-0.059 0.743,-0.058C0.76,-0.054 0.775,-0.048 0.789,-0.041ZM0.247,-0.373C0.243,-0.315 0.238,-0.25 0.269,-0.18C0.285,-0.179 0.301,-0.177 0.318,-0.172C0.319,-0.172 0.32,-0.172 0.321,-0.171C0.317,-0.196 0.319,-0.219 0.32,-0.239C0.322,-0.26 0.323,-0.277 0.317,-0.287C0.315,-0.291 0.314,-0.295 0.315,-0.299C0.316,-0.303 0.319,-0.307 0.323,-0.309C0.326,-0.311 0.331,-0.312 0.335,-0.31C0.339,-0.309 0.342,-0.307 0.344,-0.303C0.35,-0.293 0.366,-0.285 0.384,-0.276C0.402,-0.267 0.423,-0.257 0.443,-0.241C0.443,-0.243 0.443,-0.244 0.443,-0.245C0.448,-0.262 0.454,-0.277 0.461,-0.291C0.416,-0.353 0.357,-0.381 0.305,-0.406C0.285,-0.416 0.266,-0.426 0.249,-0.436C0.25,-0.417 0.248,-0.395 0.247,-0.373ZM0.585,-0.259L0.551,-0.129C0.562,-0.128 0.573,-0.129 0.584,-0.133C0.591,-0.144 0.601,-0.153 0.612,-0.16C0.618,-0.163 0.624,-0.166 0.63,-0.169C0.634,-0.176 0.638,-0.184 0.64,-0.192C0.659,-0.262 0.64,-0.318 0.623,-0.367C0.618,-0.382 0.613,-0.396 0.609,-0.409C0.6,-0.399 0.588,-0.389 0.576,-0.379C0.537,-0.345 0.493,-0.307 0.474,-0.237C0.472,-0.228 0.471,-0.22 0.471,-0.211C0.475,-0.206 0.479,-0.201 0.482,-0.195C0.489,-0.183 0.492,-0.171 0.493,-0.158C0.5,-0.149 0.51,-0.142 0.52,-0.137L0.555,-0.268C0.557,-0.276 0.566,-0.281 0.574,-0.279C0.583,-0.277 0.588,-0.268 0.585,-0.259Z" style="fill:url(#_Linear1);fill-rule:nonzero;"></path>
            </g>
        </g>
      <g transform="matrix(0.870642,0,0,1.16086,-93.8392,103.976)">
            <g transform="matrix(0.40061,0,0,0.300457,298.761,55.0601)">
                <path d="M0,25.863L0,32.537L-28.151,32.537L-28.151,-6.674L-20.195,-6.674L-20.195,25.863L0,25.863Z" style="fill:rgb(76,76,76);fill-rule:nonzero;"></path>
            </g>
        <g transform="matrix(0.40061,0,0,0.300457,313.091,55.1269)">
                <path d="M0,25.418L0,32.314L-30.098,32.314L-30.098,-6.896L-1.168,-6.896L-1.168,-0L-22.365,-0L-22.365,9.956L-4.618,9.956L-4.618,16.63L-22.365,16.63L-22.365,25.418L0,25.418Z" style="fill:rgb(76,76,76);fill-rule:nonzero;"></path>
            </g>
        <g transform="matrix(0.40061,0,0,0.300457,334.108,55.0601)">
                <path d="M0,25.863L0,32.537L-28.151,32.537L-28.151,-6.674L-20.195,-6.674L-20.195,25.863L0,25.863Z" style="fill:rgb(76,76,76);fill-rule:nonzero;"></path>
            </g>
        <g transform="matrix(0.40061,0,0,0.300457,347.279,64.8361)">
                <path d="M0,-39.211L-15.077,-13.293L-15.077,0L-23.088,0L-23.088,-13.293L-38.109,-39.211L-29.041,-39.211L-19.027,-21.914L-9.124,-39.211L0,-39.211Z" style="fill:rgb(76,76,76);fill-rule:nonzero;"></path>
            </g>
        <g transform="matrix(0.40061,0,0,0.300457,360.162,56.5306)">
                <path d="M0,16.13C0,23.693 -6.064,28.144 -15.188,28.144C-21.864,28.144 -25.258,27.531 -31.488,24.417L-28.596,18.243C-23.422,20.746 -19.806,21.246 -14.91,21.246C-10.626,21.246 -8.067,19.69 -8.067,16.797C-8.067,14.127 -10.682,12.959 -16.412,11.625C-24.479,9.789 -30.988,7.509 -30.988,-0.223C-30.988,-7.119 -25.48,-12.014 -16.523,-12.014C-10.57,-12.014 -5.341,-10.512 -1.502,-8.843L-4.729,-2.503C-8.178,-3.948 -13.018,-5.116 -16.69,-5.116C-20.696,-5.116 -22.921,-3.337 -22.921,-0.89C-22.921,1.892 -20.139,3.06 -14.242,4.395C-5.786,6.285 0,8.955 0,16.13" style="fill:rgb(76,76,76);fill-rule:nonzero;"></path>
            </g>
        <g transform="matrix(0.40061,0,0,0.300457,376.765,55.1269)">
                <path d="M0,25.418C5.508,25.418 7.789,22.748 7.789,19.077C7.789,15.907 5.452,12.682 0.056,12.682L-9.458,12.682L-9.458,25.418L0,25.418ZM-9.514,6.786L-2.337,6.786C0.334,6.786 1.391,5.006 1.391,3.393C1.391,1.502 -0.167,-0 -2.948,-0L-9.514,-0L-9.514,6.786ZM5.619,7.564C11.85,8.398 16.189,13.738 16.189,19.911C16.189,26.419 12.072,32.314 4.34,32.314L-17.246,32.314L-17.246,-6.896L0,-6.896C4.673,-6.896 8.512,-3.059 8.512,1.78C8.512,4.005 7.455,6.452 5.619,7.564" style="fill:rgb(76,76,76);fill-rule:nonzero;"></path>
            </g>
        <g transform="matrix(0.40061,0,0,0.300457,396.913,55.0601)">
                <path d="M0,25.863L0,32.537L-28.15,32.537L-28.15,-6.674L-20.195,-6.674L-20.195,25.863L0,25.863Z" style="fill:rgb(76,76,76);fill-rule:nonzero;"></path>
            </g>
        <g transform="matrix(0.40061,0,0,0.300457,411.243,55.1269)">
                <path d="M0,25.418L0,32.314L-30.098,32.314L-30.098,-6.896L-1.169,-6.896L-1.169,-0L-22.365,-0L-22.365,9.956L-4.618,9.956L-4.618,16.63L-22.365,16.63L-22.365,25.418L0,25.418Z" style="fill:rgb(76,76,76);fill-rule:nonzero;"></path>
            </g>
        <g transform="matrix(0.40061,0,0,0.300457,427.579,57.918)">
                <path d="M0,7.285C0,16.296 -6.008,23.471 -17.413,23.471C-28.762,23.471 -34.715,16.351 -34.715,7.285L-34.715,-16.186L-26.926,-16.186L-26.926,5.227C-26.926,12.625 -23.644,16.129 -17.413,16.129C-11.07,16.129 -7.788,12.569 -7.788,5.227L-7.788,-16.186L0,-16.186L0,7.285Z" style="fill:rgb(76,76,76);fill-rule:nonzero;"></path>
            </g>
        </g>
      <g transform="matrix(0.870642,0,0,1.16086,-93.8392,103.976)">
            <g transform="matrix(0.40061,0,0,0.300457,293.001,77.3669)">
                <path d="M0,-23.739L-3.744,-23.739L-5.668,-20.203L-5.668,-20.047L-2.86,-20.047L0,-23.608L0,-23.739ZM2.522,0L-11.102,0L-11.102,-18.2L2.522,-18.2L2.522,-14.872L-7.696,-14.872L-7.696,-10.686L2.158,-10.686L2.158,-7.488L-7.696,-7.488L-7.696,-3.38L2.522,-3.38L2.522,0Z" style="fill:rgb(111,111,111);fill-rule:nonzero;"></path>
            </g>
        <g transform="matrix(0.40061,0,0,0.300457,300.878,72.8908)">
                <path d="M0,11.596L3.744,11.596C7.878,11.596 9.516,8.579 9.438,5.616C9.36,2.782 7.696,-0.052 3.744,-0.052L0,-0.052L0,11.596ZM12.844,5.641C12.922,10.243 10.114,14.898 3.744,14.898L-3.406,14.898L-3.406,-3.302L3.744,-3.302C9.984,-3.302 12.767,1.143 12.844,5.641" style="fill:rgb(111,111,111);fill-rule:nonzero;"></path>
            </g>
        <g transform="matrix(0.40061,0,0,0.300457,162.051,28.2839)">
                <rect x="373.402" y="145.161" width="3.406" height="18.2" style="fill:rgb(111,111,111);"></rect>
            </g>
        <g transform="matrix(0.40061,0,0,0.300457,321.098,76.4298)">
                <path d="M0,-11.962L-5.772,-11.962L-5.772,-15.081L9.205,-15.081L9.205,-11.962L3.433,-11.962L3.433,3.119L0,3.119L0,-11.962Z" style="fill:rgb(111,111,111);fill-rule:nonzero;"></path>
            </g>
        <g transform="matrix(0.40061,0,0,0.300457,162.051,28.2839)">
                <rect x="419.77" y="145.161" width="3.406" height="18.2" style="fill:rgb(111,111,111);"></rect>
            </g>
        <g transform="matrix(0.40061,0,0,0.300457,338.705,74.5937)">
                <path d="M0,0.312C0.078,3.301 1.69,6.499 5.98,6.499C10.271,6.499 11.883,3.276 11.935,0.286C11.986,-2.783 10.271,-6.214 5.98,-6.214C1.69,-6.214 -0.078,-2.756 0,0.312M15.314,0.234C15.263,4.94 12.377,9.646 5.98,9.646C-0.416,9.646 -3.38,5.043 -3.38,0.259C-3.38,-4.525 -0.312,-9.334 5.98,-9.334C12.247,-9.334 15.367,-4.525 15.314,0.234" style="fill:rgb(111,111,111);fill-rule:nonzero;"></path>
            </g>
        <g transform="matrix(0.40061,0,0,0.300457,355.227,77.3749)">
                <path d="M0,-18.253L3.433,-18.253L3.433,-0.026L1.301,-0.026L1.301,0L-8.268,-12.299L-8.268,-0.026L-11.7,-0.026L-11.7,-18.227L-8.918,-18.227L0,-6.942L0,-18.253Z" style="fill:rgb(111,111,111);fill-rule:nonzero;"></path>
            </g>
        <g transform="matrix(0.40061,0,0,0.300457,367.062,75.9994)">
                <path d="M0,-9.255C-0.624,-10.295 -2.34,-11.283 -4.316,-11.283C-6.864,-11.283 -8.087,-10.217 -8.087,-8.865C-8.087,-7.278 -6.215,-6.837 -4.03,-6.576C-0.234,-6.109 3.302,-5.121 3.302,-0.778C3.302,3.277 -0.286,5.019 -4.343,5.019C-8.061,5.019 -10.921,3.876 -12.272,0.548L-9.412,-0.935C-8.606,1.067 -6.5,1.951 -4.29,1.951C-2.132,1.951 -0.104,1.197 -0.104,-0.778C-0.104,-2.494 -1.898,-3.196 -4.316,-3.457C-8.034,-3.899 -11.467,-4.887 -11.467,-8.969C-11.467,-12.713 -7.774,-14.247 -4.42,-14.274C-1.586,-14.274 1.352,-13.467 2.729,-10.659L0,-9.255Z" style="fill:rgb(111,111,111);fill-rule:nonzero;"></path>
            </g>
        </g>
    </g>
              <defs>
        <linearGradient id="_Linear1" x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="matrix(1,-2.77556e-17,-2.77556e-17,-1,0,-0.00174744)"><stop offset="0" style="stop-color:rgb(178,194,45);stop-opacity:1"></stop><stop offset="1" style="stop-color:rgb(31,194,240);stop-opacity:1"></stop></linearGradient>
    </defs>
</svg>
          </p>-->
          <p class="text-2xl font-weight-semibold text--primary mb-2">
            {{ $t("Bienvenue dans ORUS !") }} 👋🏻
          </p>
          <p class="mb-2">
            {{ $t("Veuillez vous connecter à votre compte.") }}
          </p>
        </v-card-text>

        <!-- login form -->
        <v-card-text>
          <v-form
            ref="loginForm"
            @submit.prevent="handleFormSubmit"
          >
            <v-text-field
              v-model="email"
              outlined
              :label="$t('Email')"
              :placeholder="$t('Email')"
              :error-messages="errorMessages.email"
              :rules="[validators.required, validators.emailValidator]"
            ></v-text-field>

            <v-text-field
              v-model="password"
              outlined
              :type="isPasswordVisible ? 'text' : 'password'"
              :label="$t('Mot de passe')"
              :error-messages="errorMessages.password"
              placeholder="············"
              :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
              :rules="[validators.required]"
              hide-details
              @click:append="isPasswordVisible = !isPasswordVisible"
            ></v-text-field>

            <div class="d-flex align-center justify-space-between flex-wrap">
              <v-checkbox
                :label="$t('Se souvenir de moi')"
                hide-details
                class="me-3 mt-1"
              >
              </v-checkbox>

              <!-- forgot link -->
              <router-link
                :to="{name:'auth-forgot-password'}"
                class="mt-1"
              >
                {{ $t("Mot de passe oublié ?") }}
              </router-link>
            </div>

            <v-btn
              block
              color="primary"
              class="mt-6"
              type="submit"
              :loading="isLoading"
            >
              {{ $t("Connexion") }}
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
    <v-snackbar
      v-model="isSnackbarBottomVisible"
      :color="$vuetify.theme.currentTheme.error"
      :light="$vuetify.theme.dark"
    >
      {{ snackBarMessage }}
    </v-snackbar>
    <!-- background triangle shape  -->
    <img
      class="auth-mask-bg"
      height="173"
      :src="require(`@/assets/images/misc/mask-${$vuetify.theme.dark ? 'dark':'light'}.png`)"
    >

    <!-- tree -->
    <v-img
      class="auth-tree"
      width="247"
      height="185"
      src="@/assets/images/misc/tree.png"
    ></v-img>

    <!-- tree  -->
    <v-img
      class="auth-tree-3"
      width="377"
      height="289"
      src="@/assets/images/misc/tree-3.png"
    ></v-img>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiFacebook, mdiTwitter, mdiGithub, mdiGoogle, mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { getCurrentInstance, ref } from '@vue/composition-api'
import themeConfig from '@themeConfig'
import { useRouter } from '@core/utils'
import { emailValidator, required } from '@core/utils/validation'
import axios from '@axios'
import store from '@/store'
import ability from '@/plugins/acl/ability'

export default {
  setup() {
    const vm = getCurrentInstance().proxy
    // Template Ref
    const loginForm = ref(null)

    const { router } = useRouter()
    const isSnackbarBottomVisible = ref(false)
    const snackBarMessage = ref('')
    const isPasswordVisible = ref(false)
    const isLoading = ref(false)
    const email = ref('')
    const password = ref('')
    const errorMessages = ref({ })
    const socialLink = [
      {
        icon: mdiFacebook,
        color: '#4267b2',
        colorInDark: '#4267b2',
      },
      {
        icon: mdiTwitter,
        color: '#1da1f2',
        colorInDark: '#1da1f2',
      },
      {
        icon: mdiGithub,
        color: '#272727',
        colorInDark: '#fff',
      },
      {
        icon: mdiGoogle,
        color: '#db4437',
        colorInDark: '#db4437',
      },
    ]
    localStorage.removeItem('userData')
    localStorage.removeItem('userAbility')

    // Reset ability
    vm.$ability.update([])
    axios.get('/logout').then(() => {})
    const handleFormSubmit = () => {
      const isFormValid = loginForm.value.validate()

      if (!isFormValid) return

      /*
        1. Make HTTP request to get accessToken
        2. Store received token in localStorage for future use
        3. Make another HTTP request for getting user information
        4. On successful response of user information redirect to home page

        ? We have use promise chaining to get user data from access token
        ? Promise Chaining: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Using_promises#chaining
      */
      isLoading.value = true
      axios({
        method: 'post',
        url: '/connect',
        data: { email: email.value, password: password.value },
        // eslint-disable-next-line no-unused-vars
        validateStatus: status => true,
      }).catch(error => {
        // this.loading = false
        isLoading.value = false
        console.log(error)
        // eslint-disable-next-line consistent-return
      }).then(response => {
        if (response.data.error || response.data.errors || (response.data.status && response.data.status === 'false')) {
          if (response.data.errors) {
            // this.toast(this.$t('These credentials do not match our records'), this.$vuetify.theme.currentTheme.error)
            errorMessages.value = { ...response.data.errors }
          } else {
            isSnackbarBottomVisible.value = true
            snackBarMessage.value = response.data.message

            // this.toast(response.data.message, this.$vuetify.theme.currentTheme.error)
          }

          return false
        }
        if (response.data.data && response.data.data.id) {
          /* this.$store.set('user/login', true)
          this.$store.set('user/user', response.data.data)
          this.$router.push('/') */
          isLoading.value = false
          // store.dispatch('app/setUser', response.data.data)

          const user = response.data.data

          var userAbility = user.permissions.map(item => {
            const actionResource = item.split('-')
            if (actionResource.length > 0) {
              const action = actionResource[0]
              const subject = actionResource[1]

              return { action, subject }
            }

            return { action: item, subject: item }
          })
          userAbility.push({ action: 'read', subject: 'Public' })

          // Set user ability
          // ? https://casl.js.org/v5/en/guide/intro#update-rules
          ability.update(userAbility)

          // Set user's ability in localStorage for Access Control
          localStorage.setItem('userAbility', JSON.stringify(userAbility))

          // We will store `userAbility` in localStorage separate from userData
          // Hence, we are just removing it from user object
          delete user.permissions
          store.state.app.user = user

          // Set user's data in localStorage for UI/Other purpose
          localStorage.setItem('userData', JSON.stringify(user))
          router.push('/')

          /* // const { user } = response.data.data
          const user = {
            ...response.data.data,
            role: 'admin',
            avatar: require('@/assets/images/avatars/1.png'),
            fullName: response.data.data.name,
            permissions: [/!* 'edit-article', 'view-role', *!/'read-ACL', 'read-Public', 'manage-all'],
          }

          const userAbility = user.permissions.map(item => {
            const actionResource = item.split('-')
            if (actionResource.length > 0) {
              const action = actionResource[0]
              const subject = actionResource[1]

              return { action, subject }
            }

            return { action: item, subject: item }
          })

          // Set user ability
          // ? https://casl.js.org/v5/en/guide/intro#update-rules
          vm.$ability.update(userAbility)

          // Set user's ability in localStorage for Access Control
          localStorage.setItem('userAbility', JSON.stringify(userAbility))

          // We will store `userAbility` in localStorage separate from userData
          // Hence, we are just removing it from user object
          delete user.permissions

          // Set user's data in localStorage for UI/Other purpose
          localStorage.setItem('userData', JSON.stringify(user)) */
        }
      }).then(() => {
        isLoading.value = false
      })
        .catch(error => {
        // TODO: Next Update - Show notification
          console.error('Oops, Unable to login!')
          console.log('error :>> ', error)

          /* errorMessages.value = error.response.data.error */
        })
    }

    return {
      handleFormSubmit,
      isPasswordVisible,
      isSnackbarBottomVisible,
      snackBarMessage,
      isLoading,
      email,
      password,
      errorMessages,
      socialLink,
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
      validators: {
        required,
        emailValidator,
      },

      // themeConfig
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,

      // Template Refs
      loginForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/pages/auth.scss';
</style>
